import React from 'react';
import { bool, func, string } from 'prop-types';


const CaretDown = props => {
  let ariaLabelledBy;
  let titleId;
  let descId;

  const {
    hidden, title, desc, role,
    width, height, viewBox,
    fill, className, x, y,
    onClick
  } = props;

  if (title) {
    titleId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy = `${titleId}`;
  }

  if (desc) {
    descId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy += ` ${descId}`;
  }

  return (
    <svg className={ className } onClick={ onClick }
      width={ width }
      height={ height }
      viewBox={ viewBox }
      fill={ fill }
      role={ role }
      aria-labelledby={ ariaLabelledBy }
      aria-hidden={ hidden }>

      {title
        ? <title id={ titleId }>{ title }</title>
        : null
      }

      {desc
        ? <desc id={ descId }>{ desc }</desc>
        : null
      }

      <g>
        <polygon points="0 0 4 5.19614188 8 0"></polygon>
      </g>
    </svg>
  );
};

CaretDown.defaultProps = {
  className: '',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: '#000000',
  role: 'img',
  title: '',
  desc: '',
  hidden: false
};

CaretDown.propTypes = {
  className: string,
  width: string,
  height: string,
  viewBox: string,
  fill: string,
  role: string,
  title: string,
  desc: string,
  hidden: bool,
  onClick: func
};


export default CaretDown;
